import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-modal-header',
  templateUrl: './custom-modal-header.component.html',
  styleUrls: ['./custom-modal-header.component.scss']
})
export class CustomModalHeaderComponent {
  @Input() title!: string;
  @Input() showReturn: boolean = false;
  @Input() hideClose: boolean = false;

  @Output() onCloseClick = new EventEmitter<number>();
  @Output() onReturnClick = new EventEmitter<number>();
}
